import React, { useContext, useState } from "react"
import { Link } from "gatsby";
import {
    GlobalStateContext,
  } from "../../state/GlobalContextProvider"
  import { admin_nav  } from "../../state/admin_nav";

const AdminTopBar = ({children}) => {

    const themeState = useContext(GlobalStateContext);
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    const [breadcrumb, setBreadcrumb] = useState([]);
    const [subHeading, setSubHeading] = useState('');
    const [heading, setHeading] = useState('');
    React.useEffect(() => {
      let breadcrumb_array = [];
      let breadcrumb_built = build_breadcrumb(admin_nav, breadcrumb_array);
      //setSubHeading(breadcrumb_built[0].name);
      setHeading(breadcrumb_built.slice(-1)[0].name);
      setBreadcrumb(breadcrumb_built);
    },[path]);

   

    

    const build_breadcrumb = (navArr, breadcrumb_array) => {
      
      var partiallyActiveItem = navArr.filter(function (item) {
        var searchPattern = new RegExp("^" + item.location);
        return searchPattern.test(path);
      });
      //setBreadcrumb
      if(partiallyActiveItem[0]){
      breadcrumb_array.push(partiallyActiveItem[0]);

      if (partiallyActiveItem[0].children !== undefined) {
        breadcrumb_array = build_breadcrumb(partiallyActiveItem[0].children, breadcrumb_array);

      } 
    }
        return breadcrumb_array;
      
      
    };

    return (
        <div className={"top-bar " + themeState.theme}>
            <div className={"SectionHeading " + themeState.theme}>
              <div>
                <div className="-intro-x newbreadcrumb hidden sm:flex w-full">
                {breadcrumb.map((menuItem, index) => (
                  <><Link to={menuItem.location} className="">
                    {menuItem.name}
                  </Link><i className="ti-angle-right newbreadcrumb__icon">/</i></>))}
                 
                  
                </div>
              </div>
              
              <h3>{heading}</h3>
            </div>
            </div>
    );
}

export default AdminTopBar;